import { FC, PropsWithChildren } from "react";

interface Props {
  label: string;
  conditionLabel: JSX.Element;
  onTap?: () => void;
  formatCondition?: (value: string) => string;
}

const SearchConditionsTile: FC<PropsWithChildren<Props>> = ({
  onTap,
  label,
  conditionLabel,
  children,
}) => {
  return (
    <button
      className="flex items-start justify-between py-8 flex-1"
      onClick={onTap}
      type="button"
    >
      <div className="flex space-x-16">
        <div className="text-sm font-bold w-100 text-left whitespace-pre-line">
          {label}
        </div>
        <div className="text-xs text-left">{conditionLabel}</div>
        {children}
      </div>

      <i className="icon-Arrow-right text-2xl" />
    </button>
  );
};
export default SearchConditionsTile;
